import { render, staticRenderFns } from "./listado.vue?vue&type=template&id=516824f1&scoped=true"
import script from "./listado.vue?vue&type=script&lang=js"
export * from "./listado.vue?vue&type=script&lang=js"
import style0 from "./listado.vue?vue&type=style&index=0&id=516824f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516824f1",
  null
  
)

export default component.exports